module.exports = __webpack_public_path__ + "img/certificate_21236145_00.d946ddbe.png";